import {
  FETCH_PRODUCTION_ORDERS,
  FETCH_PRODUCTION_ORDERS_SUCCESS,
  FETCH_PRODUCTION_ORDERS_FAIL,
  FETCH_PRODUCTION_TASKS,
  FETCH_PRODUCTION_TASKS_SUCCESS,
  FETCH_PRODUCTION_TASKS_FAIL,
  UPDATE_ORDER_STATUS,
  UPDATE_ORDER_STATUS_SUCCESS,
  UPDATE_ORDER_STATUS_FAIL,
  BULK_UPDATE_ORDERS,
  BULK_UPDATE_ORDERS_SUCCESS,
  BULK_UPDATE_ORDERS_FAIL,
  CLEAR_PRODUCTION_CACHE,
  SET_PRODUCTION_FILTER,
} from "./actionTypes"

const CACHE_DURATION = 60000 // 1 minute cache

const initialState = {
  orders: [],
  tasks: [],
  loading: false,
  tasksLoading: false,
  updating: false,
  error: null,
  lastFetched: null,
  tasksLastFetched: null,
  filter: "DEFAULT",
}

const production = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCTION_ORDERS:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case FETCH_PRODUCTION_ORDERS_SUCCESS:
      return {
        ...state,
        orders: action.payload,
        loading: false,
        lastFetched: Date.now(),
        error: null,
      }

    case FETCH_PRODUCTION_ORDERS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case FETCH_PRODUCTION_TASKS:
      return {
        ...state,
        tasksLoading: true,
      }

    case FETCH_PRODUCTION_TASKS_SUCCESS:
      return {
        ...state,
        tasks: action.payload,
        tasksLoading: false,
        tasksLastFetched: Date.now(),
      }

    case FETCH_PRODUCTION_TASKS_FAIL:
      return {
        ...state,
        tasksLoading: false,
        error: action.payload,
      }

    case UPDATE_ORDER_STATUS:
    case BULK_UPDATE_ORDERS:
      return {
        ...state,
        updating: true,
      }

    case UPDATE_ORDER_STATUS_SUCCESS:
      return {
        ...state,
        updating: false,
        orders: state.orders.map((o) =>
          o.id === action.payload.id ? { ...o, ...action.payload } : o
        ),
      }

    case BULK_UPDATE_ORDERS_SUCCESS:
      const updatedIds = action.payload.map((o) => o.id)
      return {
        ...state,
        updating: false,
        orders: state.orders.map((o) => {
          const updated = action.payload.find((u) => u.id === o.id)
          return updated ? { ...o, ...updated } : o
        }),
      }

    case UPDATE_ORDER_STATUS_FAIL:
    case BULK_UPDATE_ORDERS_FAIL:
      return {
        ...state,
        updating: false,
        error: action.payload,
      }

    case CLEAR_PRODUCTION_CACHE:
      return {
        ...state,
        lastFetched: null,
        tasksLastFetched: null,
      }

    case SET_PRODUCTION_FILTER:
      return {
        ...state,
        filter: action.payload,
      }

    default:
      return state
  }
}

export default production

// Selectors
export const selectOrders = (state) => state.production.orders
export const selectTasks = (state) => state.production.tasks
export const selectLoading = (state) => state.production.loading
export const selectUpdating = (state) => state.production.updating
export const selectFilter = (state) => state.production.filter

export const selectOrdersByStatus = (state, statuses) => {
  if (!Array.isArray(statuses)) statuses = [statuses]
  return state.production.orders.filter((o) => statuses.includes(o.status))
}

export const selectIsCacheValid = (state) => {
  const { lastFetched } = state.production
  if (!lastFetched) return false
  return Date.now() - lastFetched < CACHE_DURATION
}

export const selectTasksCacheValid = (state) => {
  const { tasksLastFetched } = state.production
  if (!tasksLastFetched) return false
  return Date.now() - tasksLastFetched < CACHE_DURATION
}
